import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { FaWhatsapp } from 'react-icons/fa';
import { FiArrowUp } from 'react-icons/fi';
import { publicAPI } from '../../services/api';
import './Layout.css';

const Layout = () => {
  const [whatsappNumber, setWhatsappNumber] = useState('584120000000'); // Número por defecto
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    publicAPI.getConfiguration().then(response => {
      if (response.data && response.data.whatsapp_number) {
        setWhatsappNumber(response.data.whatsapp_number);
      }
    }).catch(console.error);

    // Lógica para mostrar/ocultar botón al hacer scroll
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 300) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 300) {
        setShowScroll(false);
      }
    };

    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScroll]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      
      <button 
        className={`scroll-top ${showScroll ? 'visible' : ''}`} 
        onClick={scrollTop}
        aria-label="Volver arriba"
      >
        <FiArrowUp />
      </button>

      <a 
        href={`https://wa.me/${whatsappNumber}`}
        className="whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Layout;
